import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-helpbutton-reports-totalqueryphysical-card',
  templateUrl: './helpbutton-reports-totalqueryphysical-card.component.html',
  styleUrls: ['./helpbutton-reports-totalqueryphysical-card.component.scss']
})
export class HelpbuttonReportsTotalqueryphysicalCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
